<ng-container [caLocalizationScope]="localizationScope">
  <span
    *ngIf="selected && securities.length < 2"
    class="badge badge-neutral fw-bold badge-truncate ca-ticker-selector"
    [ngbTooltip]="securityFullNameFn(selected)"
    [placement]="tooltipPlacement"
  >
    {{ securityShortNameFn(selected) }}
  </span>
  <i
    *ngIf="showLoaAlerts && selected && securities.length < 2 && selected.loaAlertStatus"
    class="f-i f-i-pdf ms-1"
    [class.text-danger]="selected.loaAlertStatus === 'expired'"
    [class.text-warning]="selected.loaAlertStatus === 'expiring'"
  ></i>

  <f-dropdown
    *ngIf="securities.length >= 2 && securities.length <= 5"
    [text]="selected ? securityShortNameFn(selected) : ''"
    [tooltip]="selected ? securityFullNameFn(selected) : ('selectPinnedSecurities' | caLocalize)"
    [btnStyle]="'btn-secondary dropdown-toggle ca-ticker-selector'"
    [mobileMenuTitle]="'searchForSecurityPlaceholder' | caLocalize"
    [menuCssClass]="'ca-security-dropdown-menu'"
    [tooltipPlacement]="tooltipPlacement"
    [placement]="'bottom-left'"
    class="f-drawer-outclick-element"
  >
    <f-list class="overflow-auto">
      <ng-container *ngFor="let security of securities">
        <f-list-item
          fDropdownItem
          *ngIf="security.id"
          [title]="securityFullNameFn(security)"
          [class.active]="security.id === selected?.id"
          (keyup.enter)="onSelect(security)"
          (click)="onSelect(security)"
          class="text-truncate d-flex align-items-center justify-content-between"
        >
          <span class="text-truncate">{{ securityFullNameFn(security) }}</span>
          <i
            *ngIf="showLoaAlerts && security.loaAlertStatus"
            class="f-i f-i-pdf ms-2 flex-shrink-0"
            [class.text-danger]="security.loaAlertStatus === 'expired'"
            [class.text-warning]="security.loaAlertStatus === 'expiring'"
          ></i>
        </f-list-item>
      </ng-container>
    </f-list>
  </f-dropdown>

  <f-single-suggester-dropdown
    #suggester
    *ngIf="securities.length > 5"
    [icon]="''"
    [minLength]="1"
    [hideCaret]="false"
    [isOutlineInput]="false"
    [valuePath]="'longName'"
    [categoryPath]="'category'"
    [items]="suggesterSecurities"
    [buttonTooltipPlacement]="tooltipPlacement"
    [btnStyle]="'btn-secondary ca-ticker-selector-btn'"
    [buttonText]="selected ? securityShortNameFn(selected) : ''"
    [buttonTooltip]="selected ? securityFullNameFn(selected) : ''"
    [activeItemValue]="selected ? securityFullNameFn(selected) : ''"
    [placeholder]="'searchForSecurityPlaceholder' | caLocalize"
    [dropdownCssClass]="'suggester-dropdown-menu'"
    (select)="onSelect($any($event))"
    class="f-drawer-outclick-element"
  >
    <ng-template
      #fSuggesterItemTemplate
      let-item="item"
      let-inputValue="inputValue"
      let-isSingleListItem="isSingleListItem"
    >
      <div class="d-flex justify-content-between align-items-center">
        <span
          *ngIf="item.id; else setSecurities"
          class="text-truncate pe-3"
          innerHTML="{{ item.longName | fHighlight : inputValue }}"
        ></span>
        <i
          *ngIf="showLoaAlerts && item.id && item.loaAlertStatus"
          class="f-i f-i-pdf flex-shrink-0"
          [class.text-danger]="item.loaAlertStatus === 'expired'"
          [class.text-warning]="item.loaAlertStatus === 'expiring'"
        ></i>
      </div>
      <ng-template #setSecurities>
        <span *ngIf="isSingleListItem" class="link link-primary" (click)="onSetSecurities()"
          >{{ 'setSecurities' | caLocalize }}
        </span>
      </ng-template>
    </ng-template>
  </f-single-suggester-dropdown>
</ng-container>
